import React from "react";
import { motion } from "framer-motion";
import { MapPin, Sparkles } from "lucide-react";

export function About({ t }) {
  return (
    <section id="about" className="relative section-pad">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          {/* Left: portrait card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="md:col-span-5 relative"
          >
            <div className="relative bg-[#1C2331] border border-white/10 rounded-sm overflow-hidden">
              <div
                className="aspect-[4/5] w-full bg-cover bg-center"
                style={{
                  backgroundImage: "url('/portrait.jpg')",
                  filter: "grayscale(0.15) contrast(1.05)",
                }}
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(11,19,43,0.0) 0%, rgba(11,19,43,0.45) 55%, rgba(11,19,43,0.92) 100%)",
                }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-2 text-[#00E5FF]">
                  <MapPin size={14} />
                  <span
                    className="text-[11px] uppercase tracking-[0.22em] font-semibold"
                    style={{ fontFamily: "'Manrope', sans-serif" }}
                  >
                    {t.contact.location}
                  </span>
                </div>
                <div
                  className="mt-2 text-white text-xl font-semibold"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {t.about.person_name}
                </div>
                <div
                  className="text-[#9BA1A6] text-sm"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                  {t.about.role}
                </div>
              </div>
            </div>

            {/* accent ticker */}
            <div className="absolute -bottom-4 -right-4 hidden md:flex items-center gap-2 bg-[#0B132B] border border-[#00E5FF]/40 px-4 py-3 rounded-sm">
              <Sparkles size={14} className="text-[#00E5FF]" />
              <span
                className="text-[11px] uppercase tracking-[0.2em] text-white font-semibold"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {t.about.badge}
              </span>
            </div>
          </motion.div>

          {/* Right: copy */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
            className="md:col-span-7"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#00E5FF]" />
              <span className="eyebrow">{t.about.eyebrow}</span>
            </div>
            <h2
              className="text-white font-semibold leading-[1.1] tracking-tight"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: "clamp(28px, 4vw, 48px)",
              }}
            >
              {t.about.heading}
            </h2>
            <p
              className="mt-6 text-[#9BA1A6] leading-relaxed"
              style={{ fontFamily: "'Manrope', sans-serif", fontSize: "17px" }}
            >
              {t.about.body_1}
            </p>
            <p
              className="mt-4 text-[#9BA1A6] leading-relaxed"
              style={{ fontFamily: "'Manrope', sans-serif", fontSize: "17px" }}
            >
              {t.about.body_2}
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {t.about.highlights.map((h, i) => (
                <div
                  key={i}
                  className="bg-[#1C2331] border border-white/10 p-5 rounded-sm hover-lift"
                >
                  <div
                    className="text-[10px] uppercase tracking-[0.24em] text-[#00E5FF] font-bold"
                    style={{ fontFamily: "'Manrope', sans-serif" }}
                  >
                    {h.label}
                  </div>
                  <div
                    className="mt-3 text-white text-sm leading-relaxed"
                    style={{ fontFamily: "'Manrope', sans-serif" }}
                  >
                    {h.text}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
